import { Link, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';
import { useLanguage } from '../hooks/useLanguage';
import LanguageSwitcher from './LanguageSwitcher';
import { LayoutDashboard, Users, LogOut, Kanban, ShoppingCart, Megaphone, FileText, MessageCircle, Phone, BarChart3, Settings } from 'lucide-react';

export default function Layout() {
  const { user, logout } = useAuth();
  const location = useLocation();
  const { t } = useLanguage();

  const navItems = [
    { path: '/', label: t('nav.dashboard'), icon: LayoutDashboard },
    { path: '/leads', label: t('nav.leads'), icon: Users },
    { path: '/pipeline', label: t('nav.pipeline'), icon: Kanban },
    { path: '/orders', label: t('nav.orders'), icon: ShoppingCart },
    { path: '/campaigns', label: t('nav.campaigns'), icon: Megaphone },
    { path: '/templates', label: t('nav.templates'), icon: FileText },
    { path: '/messages', label: t('nav.messages'), icon: MessageCircle },
    { path: '/calls', label: t('nav.calls'), icon: Phone },
    { path: '/reports', label: t('nav.reports'), icon: BarChart3 },
    { path: '/settings', label: t('nav.settings'), icon: Settings },
  ];

  return (
    <div className="min-h-screen flex">
      {/* Sidebar */}
      <aside className="w-64 bg-gray-900 text-white flex flex-col">
        <div className="p-4 border-b border-gray-800">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 bg-primary-600 rounded-lg flex items-center justify-center">
              <span className="font-bold text-lg">C</span>
            </div>
            <div className="flex-1 min-w-0">
              <h1 className="font-bold">Clal CRM</h1>
              <p className="text-xs text-gray-400 truncate">{user?.name}</p>
            </div>
          </div>
        </div>

        {/* Language Switcher */}
        <div className="px-4 py-2 border-b border-gray-800">
          <LanguageSwitcher />
        </div>

        <nav className="p-4 space-y-1 flex-1">
          {navItems.map((item) => {
            const isActive = location.pathname === item.path;
            return (
              <Link
                key={item.path}
                to={item.path}
                className={`flex items-center gap-3 px-4 py-3 rounded-lg transition ${
                  isActive
                    ? 'bg-primary-600 text-white'
                    : 'text-gray-400 hover:bg-gray-800 hover:text-white'
                }`}
              >
                <item.icon className="w-5 h-5" />
                <span>{item.label}</span>
              </Link>
            );
          })}
        </nav>

        <div className="p-4 border-t border-gray-800">
          <button
            onClick={logout}
            className="flex items-center gap-3 px-4 py-3 rounded-lg text-gray-400 hover:bg-gray-800 hover:text-white w-full transition"
          >
            <LogOut className="w-5 h-5" />
            <span>{t('nav.logout')}</span>
          </button>
        </div>
      </aside>

      {/* Main Content */}
      <main className="flex-1 p-6 overflow-y-auto">
        <Outlet />
      </main>
    </div>
  );
}
